<template>
    <v-tabs v-model="tab" show-arrows :class="`${!!errorsInTabs.find((x) => x == tab) ? 'v-tabs--error' : ''}`">
        <v-tab
            v-for="(item, index) in items"
            :key="index"
            :class="`${!!errorsInTabs.find((x) => x == index) ? 'v-tab--error' : ''}`"
        >
            <div class="tab">
                <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                <v-slide-x-transition>
                    <v-fade-transition>
                        <v-icon v-if="!!errorsInTabs.find((x) => x == index)" class="error-icon" left dense color="red"
                            >mdi-alert</v-icon
                        >
                    </v-fade-transition>
                </v-slide-x-transition>
                {{ item }}
            </div>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    data() {
        return {
            items: [t('roles::form.details'), t('roles::form.permissions')],
            tabsErrors: {
                0: ['name', 'description', 'group', 'active', 'readonly', 'reset_password'],
            },
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.dms_roles.tab;
            },
            set(value) {
                this.$store.dispatch('dms_roles/changeTab', value);
            },
        },
        errorsInTabs() {
            const errors = this.$store.state.dms_roles.errorMessages.dms_role;
            const Errors = [];
            const errorsInTabs = [];
            Object.keys(errors).forEach((val) => {
                if (errors[val] && errors[val].length) {
                    Errors.push(val);
                }
            });
            Object.keys(this.tabsErrors).forEach((tab) => {
                Object.values(this.tabsErrors[tab]).forEach((error) => {
                    if (Errors.includes(error)) {
                        errorsInTabs.push(tab);
                    }
                });
            });
            return _.sortedUniq(errorsInTabs);
        },
    },
};
</script>
